import { type Clip } from '@air/api/types';
import { ClipUtils } from '@air/utils-clips';

import { useHandleClipMediaUpdated } from '~/hooks/useHandleClipMediaUpdated';
import { useHandleClipUpdated } from '~/hooks/useHandleClipUpdated';

export type UseRegisterPublicClipEventsParams = {
  clips: Pick<Clip, 'id' | 'status'>[];
  workspaceId: string | undefined;
};

export const useRegisterClipEvents = ({ clips, workspaceId }: UseRegisterPublicClipEventsParams) => {
  /**
   * We only want to listen to clips which haven't been transcoded yet
   */
  const transcodingClipIds = clips.reduce<string[]>((ids, { status, id }) => {
    if (ClipUtils.isProcessing(status)) {
      ids.push(id);
    }
    return ids;
  }, []);

  useHandleClipUpdated({ clipIds: transcodingClipIds, workspaceId });
  useHandleClipMediaUpdated({ clipIds: transcodingClipIds, workspaceId });
};
